import React from 'react';

const More = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='26'
      height='6'
      viewBox='0 0 26 6'
      fill='none'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.77778 3C5.77778 4.6582 4.48568 6 2.88889 6C1.2921 6 0 4.6582 0 3C0 1.3418 1.2921 0 2.88889 0C4.48568 0 5.77778 1.3418 5.77778 3ZM13 0C11.4032 0 10.1111 1.3418 10.1111 3C10.1111 4.6582 11.4032 6 13 6C14.5968 6 15.8889 4.6582 15.8889 3C15.8889 1.3418 14.5968 0 13 0ZM23.1111 0C21.5143 0 20.2222 1.3418 20.2222 3C20.2222 4.6582 21.5143 6 23.1111 6C24.7079 6 26 4.6582 26 3C26 1.3418 24.7079 0 23.1111 0Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default More;
